import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initAuth } from './stores/authStore';
import './index.css';

// 应用启动时检查 Token 有效性，避免过期 token 导致路由死循环
initAuth();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
);
